import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import AppStoreButtons from "./AppStoreButtons";

function CTA() {
  return (
    <MKBox pt={20} pb={14} sx={{ background: "#32373c" }}>
      <Container maxWidth="sm">
        <MKBox textAlign="center">
          <MKTypography
            variant="caption"
            sx={{
              color: "rgba(255,255,255,0.5)",
              fontWeight: 600,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              display: "block",
              mb: 1.5,
            }}
          >
            Get Started
          </MKTypography>
          <MKTypography variant="h2" color="white" fontWeight="bold" mb={2}>
            Ready to get started?
          </MKTypography>
          <MKTypography
            variant="body1"
            sx={{ color: "rgba(255,255,255,0.7)", mb: 5, lineHeight: 1.8 }}
          >
            Download the Spechs Workforce app or contact us to set up your company account.
          </MKTypography>

          <MKBox mb={4}>
            <AppStoreButtons variant="light" justify="center" />
          </MKBox>

          <MKTypography variant="body2" sx={{ color: "rgba(255,255,255,0.55)" }}>
            Want a demo or have questions?{" "}
            <MKTypography
              component="span"
              variant="body2"
              onClick={() => window.dispatchEvent(new Event("open-contact-form"))}
              sx={{
                color: "white !important",
                cursor: "pointer",
                fontWeight: "bold",
                textDecoration: "underline",
              }}
            >
              Contact us
            </MKTypography>
          </MKTypography>

          {/* <MKTypography
            variant="caption"
            sx={{ color: "rgba(255,255,255,0.3)", display: "block", mt: 1 }}
          >
            App currently in review on App Store &amp; Google Play
          </MKTypography> */}
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default CTA;
